import { render, staticRenderFns } from "./GeofenceViewData.vue?vue&type=template&id=2542103e&"
import script from "./GeofenceViewData.vue?vue&type=script&lang=js&"
export * from "./GeofenceViewData.vue?vue&type=script&lang=js&"
import style0 from "./GeofenceViewData.vue?vue&type=style&index=0&id=2542103e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports